import React, { useState, useEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Menu } from 'lucide-react';
import Sidebar from './components/common/Sidebar';
import AppRoutes from './routes/AppRoutes';
import './index.css';

function AppLayout() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  const isPublicPage = location.pathname === '/' || location.pathname === '/login' || location.pathname === '/register';
  const showSidebar = isAuthenticated && !isPublicPage;

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <div className="app-container">
      {showSidebar && (
        <>
          <div className="mobile-header d-md-none">
            <div className="mobile-header__brand">
              <img src="/campusready_logo.svg" alt="CampusReady" />
              <span>CampusReady</span>
            </div>
            <button className="mobile-toggle-btn" onClick={() => setIsMobileMenuOpen(true)}>
              <Menu size={24} />
            </button>
          </div>
          {isMobileMenuOpen && (
            <div className="mobile-sidebar-overlay" onClick={() => setIsMobileMenuOpen(false)} />
          )}
          <Sidebar isMobileOpen={isMobileMenuOpen} setIsMobileOpen={setIsMobileMenuOpen} />
        </>
      )}
      <main className={`main-content ${showSidebar ? 'main-content--with-sidebar' : ''}`}>
        <AppRoutes />
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppLayout />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
